export default function OffcanvasReservation() {
    let currentItem = 1;
    const navItems = document.querySelectorAll('.reservation-nav ul li');
    const content = document.querySelectorAll('.reservation-content ul li');
    navItems.forEach((el) => {
        el.querySelector('a').addEventListener('click', (e) => {
            e.preventDefault();
            const index = el.getAttribute('data-index');
            if(index === currentItem) return;
            content[currentItem - 1].classList.remove('is-active');
            navItems[currentItem - 1].classList.remove('is-active');

            currentItem = index;

            content[index - 1].classList.add('is-active');
            navItems[index - 1].classList.add('is-active');
        });
    });

    if( document.querySelector('.offcanvas-reservation-close') ){
        document.querySelector('.offcanvas-reservation-close').addEventListener('click', (e) => {
            e.preventDefault();

            document.querySelector('.offcanvas-reservation').classList.remove('is-active');
        });
    }

    document.querySelectorAll('.request-button').forEach(btn => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();


        if(window.innerWidth < 768) {
          document.querySelector('.hamburger').click();
        }
        
          document.querySelector('.offcanvas-reservation').classList.add('is-active');

      });
    })

    const firstEl = document.querySelector('.reservation-content li.is-active');

    if(firstEl) {
      const content = firstEl.querySelector('.reservation-content-body');
      $(content).slideDown();
    }

    document.querySelector('.reservation-content')
    document.querySelectorAll('.reservation-content-header').forEach(header => {

      const parent = header.closest('li');
      const content = parent.querySelector('.reservation-content-body');

      header.addEventListener('click', function(){
        if(window.innerWidth < 768) {
          if(parent.classList.contains('is-active')) {
            parent.classList.remove('is-active');
            $(content).slideUp();
          } else {
            const currentEl = parent.closest('ul').querySelector('.is-active');

            if(currentEl) {
              currentEl.classList.remove('is-active');
              $(currentEl.querySelector('.reservation-content-body')).slideUp();
            }

            parent.classList.add('is-active');
            $(content).slideDown();
          }
        }
      })
    })
}
